import { Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { FaUser, FaCog, FaEdit, FaSignOutAlt } from 'react-icons/fa';

function PerfilDropdown() {
  const navigate = useNavigate();
  const [nomeUsuario, setNomeUsuario] = useState("Usuário");

  useEffect(() => {
    const nome = sessionStorage.getItem("usuarioNome");
    if (nome) {
      setNomeUsuario(nome);
    }
  }, []);

  const handleLogout = () => {
    sessionStorage.clear(); // Remove os dados do usuário
    navigate("/loginPage"); // Redireciona para a tela de login após limpar a sessão
  };

  return (
    <Dropdown>
      <Dropdown.Toggle 
        variant="light" 
        id="dropdown-perfil"
        style={{
          background: 'linear-gradient(45deg, #667eea, #764ba2)',
          color: 'white',
          border: 'none',
          borderRadius: '15px',
          padding: '12px 20px',
          fontWeight: '600',
          boxShadow: '0 5px 15px rgba(102, 126, 234, 0.4)',
          transition: 'all 0.3s ease',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = 'translateY(-2px)';
          e.target.style.boxShadow = '0 8px 25px rgba(102, 126, 234, 0.6)';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = '0 5px 15px rgba(102, 126, 234, 0.4)';
        }}
      >
        <FaUser style={{ fontSize: '16px' }} />
        Olá, {nomeUsuario}
      </Dropdown.Toggle>

      <Dropdown.Menu 
        align="end"
        style={{
          background: 'rgba(255, 255, 255, 0.98)',
          backdropFilter: 'blur(15px)',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          borderRadius: '15px',
          boxShadow: '0 15px 35px rgba(0, 0, 0, 0.15)',
          padding: '10px',
          marginTop: '10px',
          minWidth: '200px'
        }}
      >
        <Dropdown.Item 
          href="/config"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            padding: '12px 16px',
            borderRadius: '10px',
            margin: '2px 0',
            transition: 'all 0.3s ease',
            color: '#333',
            fontWeight: '500'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = 'linear-gradient(45deg, #667eea, #764ba2)';
            e.target.style.color = 'white';
            e.target.style.transform = 'translateX(5px)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'transparent';
            e.target.style.color = '#333';
            e.target.style.transform = 'translateX(0)';
          }}
        >
          <FaCog style={{ fontSize: '14px' }} />
          Configurações
        </Dropdown.Item>
        
        <Dropdown.Item 
          href="/editar-perfil"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            padding: '12px 16px',
            borderRadius: '10px',
            margin: '2px 0',
            transition: 'all 0.3s ease',
            color: '#333',
            fontWeight: '500'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = 'linear-gradient(45deg, #667eea, #764ba2)';
            e.target.style.color = 'white';
            e.target.style.transform = 'translateX(5px)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'transparent';
            e.target.style.color = '#333';
            e.target.style.transform = 'translateX(0)';
          }}
        >
          <FaEdit style={{ fontSize: '14px' }} />
          Editar Perfil
        </Dropdown.Item>
        
        <Dropdown.Divider style={{ margin: '8px 0', borderColor: 'rgba(0,0,0,0.1)' }} />
        
        <Dropdown.Item 
          href="/loginPage" 
          onClick={handleLogout}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            padding: '12px 16px',
            borderRadius: '10px',
            margin: '2px 0',
            transition: 'all 0.3s ease',
            color: '#ff416c',
            fontWeight: '600'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = 'linear-gradient(45deg, #ff416c, #ff4b2b)';
            e.target.style.color = 'white';
            e.target.style.transform = 'translateX(5px)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'transparent';
            e.target.style.color = '#ff416c';
            e.target.style.transform = 'translateX(0)';
          }}
        >
          <FaSignOutAlt style={{ fontSize: '14px' }} />
          Sair
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default PerfilDropdown;
